import React, { useState } from "react";

import { Icon, Badge } from "@culturehq/components";
import { isMicrosoft, t, Trans } from "app/utils";
import { ClubLink, InterestLink, SkillLink } from "app/links";

const TagLink = ({ label, tag }) => {
  switch (label) {
    case "INTERESTS":
      return (<InterestLink interest={tag} />);
    case "SKILLS":
      return (<SkillLink skill={tag} />);
    case "CLUBS":
      return (<ClubLink club={tag} />);
    default:
      return "";
  }
};

const Tags = ({
  icon,
  iconCommonality,
  isMyProfile,
  myTags,
  userTags,
  label,
  link,
  landingPage = false,
  color = undefined,
  orgName
}) => {
  const [expanded, setExpanded] = useState(false);

  const IS_LESS = -1;
  const IS_GREATER = 1;
  const MAX_NUMBER_TO_SHOW = 5;

  const inCommom = userTags.map(tag => (
    { ...tag, common: myTags.find(({ id }) => (id === tag.id && !isMyProfile)) }
  )).sort(({ common }) => (common ? IS_LESS : IS_GREATER));

  const handleClick = isExpanded => {
    setExpanded(isExpanded);
  };

  return (
    <div className="Interests">
      <div className="Interests__title">
        <h2 className="subtitle" style={isMicrosoft(orgName) ? {} : color && { color }}><Trans>{isMyProfile && "MY "}{label}</Trans></h2>
        {isMyProfile && (<a aria-label={t(`View all user ${label}`)} href={link}><Icon icon="ios-gear" className="category-icon" /></a>)}
      </div>
      <div className="chq-ffd-tags">
        {expanded
          ? (
            <>
              {inCommom.map(tag => (
                <Badge key={tag.id} className={tag.common ? "Common-Interest User-Interest" : "User-Interest"}>
                  <Icon icon={tag.common ? iconCommonality : icon} />
                  {landingPage
                    ? <span>{tag.name}</span>
                    : <InterestLink interest={tag} />}
                </Badge>
              ))}
              <div key="minus-option" className="Interests__minus-option">
                <span onClick={() => handleClick(false)}>
                  <Icon icon="minus" />
                  {" "}
                  show less
                </span>
              </div>
            </>
          ) : (
            <>
              {inCommom.map((tag, index) => (
                (index < MAX_NUMBER_TO_SHOW) && (
                  <Badge key={tag.id} className={tag.common ? "Common-Interest User-Interest" : "User-Interest"}>
                    <Icon icon={tag.common ? iconCommonality : icon} />
                    {landingPage
                      ? <span>{tag.name}</span>
                      : <TagLink label={label} tag={tag} />}
                  </Badge>
                )
              ))}
              {inCommom.length > MAX_NUMBER_TO_SHOW && (
                <div key="plus-option" className="Interests__plus-option">
                  <span onClick={() => handleClick(true)}>
                    <Icon icon="plus" />
                    {" "}
                    {inCommom.length - MAX_NUMBER_TO_SHOW}
                  </span>
                </div>
              )}
            </>
          )}
      </div>
    </div>
  );
};

export default Tags;
